// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { License } from "./License";
import {
  LicenseFromJSON,
  LicenseFromJSONTyped,
  LicenseToJSON,
  LicenseToJSONTyped,
} from "./License";
import type { IdentityProvider } from "./IdentityProvider";
import {
  IdentityProviderFromJSON,
  IdentityProviderFromJSONTyped,
  IdentityProviderToJSON,
  IdentityProviderToJSONTyped,
} from "./IdentityProvider";

/**
 *
 * @export
 * @interface TenantCreate
 */
export interface TenantCreate {
  /**
   *
   */
  id: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  identityProviders: Array<IdentityProvider>;
  /**
   *
   */
  threediOrganisations?: Array<string>;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  license?: License;
}

/**
 * Check if a given object implements the TenantCreate interface.
 */
export function instanceOfTenantCreate(value: object): value is TenantCreate {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("identityProviders" in (value as Record<string, any>)) &&
      !("identity_providers" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identityProviders"] === undefined &&
      (value as Record<string, any>)["identity_providers"] === undefined)
  )
    return false;
  return true;
}

export function TenantCreateFromJSON(json: any): TenantCreate {
  return TenantCreateFromJSONTyped(json, false);
}

export function TenantCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantCreate {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    identityProviders: (json["identity_providers"] as Array<any>).map(IdentityProviderFromJSON),
    threediOrganisations:
      json["threedi_organisations"] == null ? undefined : json["threedi_organisations"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    license: json["license"] == null ? undefined : LicenseFromJSON(json["license"]),
  };
}

export function TenantCreateToJSON(json: any): TenantCreate {
  return TenantCreateToJSONTyped(json, false);
}

export function TenantCreateToJSONTyped(
  value?: TenantCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    identity_providers: (value["identityProviders"] as Array<any>).map(IdentityProviderToJSON),
    threedi_organisations: value["threediOrganisations"],
    description: value["description"],
    license: LicenseToJSON(value["license"]),
  };
}
